// Test comment for git tracking
import React from "react";
import { Link } from "react-router-dom";
import useScrollHandler from "../hooks/useScrollHandler";
import "./../styles/App.css";
import "./../styles/Team.css";

import aamir from "./../assets/team/aamir.png";
import aadith from './../assets/team/aadith.jpeg';
import arissa from './../assets/team/arissa2.jpg';
import hy from './../assets/team/hy.jpeg';
import wesley from './../assets/team/wesley2.jpg';
import alex from "./../assets/team/alex.png";
import alson from "./../assets/team/alson_chan.jpg";
import aashi from "./../assets/team/alumni/aashi_jawar.png";
import abhay from "./../assets/team/alumni/abhay_malik.jpeg";
import adhiv from "./../assets/team/alumni/adhiv_dhar.png";
import adithya from "./../assets/team/alumni/adithya_paramasivam.jpeg";
import anjan from "./../assets/team/alumni/anjan_bharadwaj.jpeg";
import alice from "./../assets/team/alumni/alice_deng.jpeg";
import amrit from "./../assets/team/alumni/amrit_ayalur.jpeg";
import blake from "./../assets/team/alumni/blake_lafayette.jpeg";
import cameron from "./../assets/team/alumni/cameron_baradar.jpeg";
import damini from "./../assets/team/alumni/damini_satija.jpeg";
import daniella from "./../assets/team/alumni/daniella_wenger.jpeg";
import farbod from "./../assets/team/alumni/farbod_nowzad.jpeg";
import jasmine from "./../assets/team/alumni/jasmine_stoy.jpeg";
import jeff from "./../assets/team/alumni/jeff_feng.jpeg";
import jeremy from "./../assets/team/alumni/jeremy_fiance.jpeg";
import kathy from "./../assets/team/alumni/kathy_kong.png";
import keyan from "./../assets/team/alumni/keyan_sarrafzadeh.jpeg";
import kirtan from "./../assets/team/alumni/kirtan_upadhyaya.jpeg";
import joelene from "./../assets/team/joelene.png"
import lulu from "./../assets/team/alumni/lulu_holland.png";
import maanav from "./../assets/team/alumni/maanav_khaitan.jpeg";
import nikita from "./../assets/team/alumni/nikita_ashok.png";
import omkar from "./../assets/team/alumni/omkar_salpekar.jpeg";
import pranav from "./../assets/team/alumni/pranav_gulati.png";
import pratik from "./../assets/team/alumni/pratik_bhat.jpg";
import sam from "./../assets/team/alumni/sam_kirschner.jpeg";
import saneel from "./../assets/team/alumni/saneel_sreeni.jpg";
import sean from "./../assets/team/alumni/sean_linehan.jpeg";
import shaantam from "./../assets/team/alumni/shaantam_chawla.png";
import amy from "./../assets/team/amy.png";
import christina from "./../assets/team/christina.png";
import hiya from "./../assets/team/hiya.png";
import hriday from "./../assets/team/hriday.png";
import ishaan from "./../assets/team/ishaan.png";
import kelly from "./../assets/team/kelly.png";
import mahika from "./../assets/team/mahika_valluri.jpeg";
import nandu from "./../assets/team/nandu.png";
import pavit from "./../assets/team/pavit.png";
import radha from "./../assets/team/radha_singh.jpg";
import rohan from "./../assets/team/rohan.jpg";
import safwan from "./../assets/team/safwan.png";
import samiha from "./../assets/team/samiha.png";
import sanjay from "./../assets/team/sanjay_adhikesaven.jpeg";
import shlok from "./../assets/team/shlok.png";
import varun from "./../assets/team/varun.png";
import aathma from "./../assets/team/aathma.jpeg";
import ashni from "./../assets/team/ashni.jpeg";
import gatik from "./../assets/team/gatik.png";
import nidhi from "./../assets/team/nidhi2.jpg";
import om from "./../assets/team/om.jpeg";
import alexhan from "./../assets/team/alex2.jpg";
import amelia from "./../assets/team/amelia2.jpg";
import shreyash from "./../assets/team/shreyash2.jpg";
import aryan3 from "./../assets/team/aryan3.jpg";
import divij from "./../assets/team/divij.jpeg";
import juhi from "./../assets/team/juhi.jpeg";
import leo from "./../assets/team/leo.jpeg";
import nathan from "./../assets/team/nathan.jpeg";
import swara3 from "./../assets/team/swara3.jpg";
import shivansh2 from "./../assets/team/shivansh2.jpeg";
import aaron from "./../assets/team/aaron2.jpg";
import eleyn from "./../assets/team/eleyn2.jpg";
import daniel from "./../assets/team/daniel2.jpg";
import rohit from "./../assets/team/rohit2.jpg";
import sunskriti from "./../assets/team/sunskriti2.jpg";
import taj from "./../assets/team/taj2.jpg";

import GenericPage from "./GenericPage";
import GenericTop from "./GenericTop";
import Person from "./Person.js";

import berkeleyengineering from "./../assets/partners/berkeleyengineering.png";
import haas from "./../assets/partners/haas.jpg";
import house from "./../assets/partners/house.png";
import scet from "./../assets/partners/scet.png";
import skydeck from "./../assets/partners/skydeck.png";
import AlumniCardsMarquee from "./AlumniCardsMarquee";

function Team() {
  // var header = "Meet the Team";
  var header = "Coffee Chats Now Open!";
  var internalRecruitment = false;
  var description =
    "Interested in joining the Free Ventures batch? Use the calendar icon to schedule a coffee chat with other Free Ventures members! Fill out the form below to apply.";

  let button;

  if (internalRecruitment) {
    description +=
      " We're currently recruiting for our batch! Click below to learn more.";
    button = (
      <Link to="/apply" className="genericButton">
        Apply to batch
      </Link>
    );
  } else {
    // description +=
    //   " Click below to fill out our interest form! We'll email you once we begin recruitment in October.";
    button = (
      <a
        href="https://forms.gle/Z4MtgBDPSNSmUBADA"
        target="_blank"
        rel="noopener noreferrer"
        className="genericButton"
      >
        Batch Application
      </a>
    );
  }

  const peopleContent = [
    {
      name: "Om Gole",
      position: "Managing Director",
      linkedinUrl: "https://www.linkedin.com/in/omgole/",
      calendlyUrl: "https://calendly.com/omgole-berkeley/ubg-coffee-chats",
      mailTo: "mailto:om@freeventures.org",
      image: om,
    },
    {
      name: "Amelia Khor",
      position: "Director of Sponsorship",
      linkedinUrl: "https://www.linkedin.com/in/ameliakhor/",
      calendlyUrl: "https://calendly.com/amelia-freeventures/15min?month=2025-09&date=2025-09-06",
      mailTo: "mailto:amelia@freeventures.org",
      image: amelia,
    },
    {
      name: "Shivansh Soni",
      position: "Director of Community",
      linkedinUrl: "https://www.linkedin.com/in/shivanshsonii/",
      calendlyUrl: "https://calendly.com/shivanshmsoni/free-ventures-coffee-chats",
      mailTo: "mailto:shivansh@freeventures.org",
      image: shivansh2,
    },
    {
      name: "Alex Han",
      position: "Director of Batch",
      linkedinUrl: "https://www.linkedin.com/in/alexqhan/",
      calendlyUrl: "https://calendly.com/alexhan-berkeley/new-meeting",
      mailTo: "mailto:alex@freeventures.org",
      image: alexhan,
    },
    {
      name: "Aathma Muruganathan",
      position: "Senior Associate, Ex-Managing Director",
      linkedinUrl: "https://www.linkedin.com/in/aathma/",
      calendlyUrl: "https://calendly.com/aathma-freeventures/free-venture-coffee-chats?month=2025-02",
      mailTo: "mailto:aathma@freeventures.org",
      image: aathma,
    },  
    {
      name: "Nidhi Gaonkar",
      position: "Senior Associate, Ex-Director of Sponsorship",
      linkedinUrl: "https://www.linkedin.com/in/nidhi-gaonkar/",
      calendlyUrl: "https://calendly.com/nidhi-freeventures",
      mailTo: "mailto:nidhi@freeventures.org",
      image: nidhi,
    },
    {
      name: "Shreyash Goli",
      position: "Senior Associate, Ex-Director of Batch",
      linkedinUrl: "https://www.linkedin.com/in/shreyash-goli/",
      calendlyUrl: "https://calendly.com/shreyash_goli-berkeley/free-ventures-coffee-chats?month=2025-09",
      mailTo: "mailto:shreyash@freeventures.org",
      image: shreyash,
    },
    {
      name: "Aryan Nangia",
      position: "Senior Associate",
      linkedinUrl: "https://www.linkedin.com/in/aryan-nangia/",
      calendlyUrl: "https://calendly.com/aryan-nangia-berkeley/30min",
      mailTo: "mailto:aryan@freeventures.org",
      image: aryan3,
    },
    {
      name: "Juhi Mathur",
      position: "Senior Associate",
      linkedinUrl: "https://www.linkedin.com/in/juhi-mathur1/",
      calendlyUrl: "https://calendly.com/juhi-freeventures/30min",
      mailTo: "mailto:juhi@freeventures.org",
      image: juhi,
    },
    {
      name: "Nathan Guan",
      position: "Senior Associate",
      linkedinUrl: "https://www.linkedin.com/in/nathanrguan/",
      calendlyUrl: "https://calendly.com/nathanguan-berkeley/30min",
      mailTo: "mailto:nathan@freeventures.org",
      image: nathan,
    },
    {
      name: "Aaron Bao",
      position: "Associate",
      linkedinUrl: "https://www.linkedin.com/in/aaronsbao/",
      calendlyUrl: "https://calendar.app.google/UKa7dUeFqkthazdJ9",
      mailTo: "mailto:aaron@freeventures.org",
      image: aaron,
    },
    {
      name: "Daniel Bao",
      position: "Associate",
      linkedinUrl: "https://www.linkedin.com/in/danielbao1/",
      calendlyUrl: "https://calendly.com/daniel-bao-berkeley/30min",
      mailTo: "mailto:daniel@freeventures.org",
      image: daniel,
    },
    {
      name: "Divij Motwani",
      position: "Associate",
      linkedinUrl: "https://www.linkedin.com/in/divijmotwani/",
      calendlyUrl: "https://calendly.com/divijmotwani/divij-motwani-coffee-chat?month=2026-02",
      mailTo: "mailto:divij@freeventures.org",
      image: divij,
    },
    {
      name: "Eleyn Xiong",
      position: "Associate",
      linkedinUrl: "https://www.linkedin.com/in/eleyn-xiong/",
      calendlyUrl: "https://calendar.app.google/M1KDQaY2LbPktugv8",
      mailTo: "mailto:eleyn@freeventures.org",
      image: eleyn,
    },
    {
      name: "Leo Xu",
      position: "Associate",
      linkedinUrl: "https://www.linkedin.com/in/liyuanleoxu/",
      calendlyUrl: "https://calendly.com/leoxuliyuan-berkeley/freev-leo-xu",
      mailTo: "mailto:leo@freeventures.org",
      image: leo,
    },
    {
      name: "Rohit Sandadi",
      position: "Associate",
      linkedinUrl: "https://www.linkedin.com/in/rohitsandadi/",
      calendlyUrl: "https://calendly.com/rohitsand/chat",
      mailTo: "mailto:rohit@freeventures.org",
      image: rohit,
    },
    {
      name: "Sunskriti Jain",
      position: "Associate",
      linkedinUrl: "https://www.linkedin.com/in/sunskriti-jain/",
      calendlyUrl: "https://calendly.com/sunskritijain-berkeley/new-meeting",
      mailTo: "mailto:sunskriti@freeventures.org",
      image: sunskriti,
    },
    {
      name: "Taj Singh",
      position: "Associate",
      linkedinUrl: "https://www.linkedin.com/in/tajsinghcal/",
      calendlyUrl: " ",
      mailTo: "mailto:taj@freeventures.org",
      image: taj,
    },
    {
      name: "Arissa Zheng",
      position: "Senior Advisor, Ex-Managing Director",
      linkedinUrl: "https://www.linkedin.com/in/arissazheng/",
      calendlyUrl: "https://calendly.com/arissa-zheng/free-ventures-coffee-chats",
      mailTo: "mailto:arissa.zheng@berkeley.edu",
      image: arissa,
    },
    {
      name: "Sanjay Adhikesaven",
      position: "Senior Advisor, Ex-Managing Director",
      linkedinUrl: "https://www.linkedin.com/in/sanjayadhikesaven/",
      calendlyUrl: "https://calendly.com/sanjayadhikesaven/free-ventures-coffee-chats",
      mailTo: "mailto:sanjay@freeventures.org",
      image: sanjay,
    },
    {
      name: "Aadith Kannan",
      position: "Senior Advisor, Ex-Director",
      linkedinUrl: "https://www.linkedin.com/in/aadithkannan/",
      calendlyUrl: "https://calendly.com/aadithkannan-hkq/free-venture-coffee-chats",
      mailTo: "mailto:aadith@freeventures.org",
      image: aadith,
    },
    {
      name: "Gatik Trivedi",
      position: "Senior Advisor, Ex-Director",
      linkedinUrl: "https://www.linkedin.com/in/gatik-trivedi/",
      calendlyUrl: "https://calendly.com/gatiktrivedi-berkeley/freev",
      mailTo: "mailto:gatik@freeventures.org",
      image: gatik,
    },
    {
      name: "Wesley Perronne",
      position: "Senior Advisor, Ex-Director",
      linkedinUrl: "https://www.linkedin.com/in/wesley-perronne/",
      calendlyUrl: "https://calendly.com/wesley-perronne-berkeley/free-ventures-1",
      mailTo: "mailto:wesley@freeventures.org",
      image: wesley,
    },
    {
      name: "Swara Agarwal",
      position: "Senior Advisor",
      linkedinUrl: "https://www.linkedin.com/in/swara-agarwal/",
      calendlyUrl: "https://calendly.com/swara-agarwal-sca/freev-20-min-coffee-chat",
      mailTo: "mailto:swara@freeventures.org",
      image: swara3,
    }
  ];

  const alumniContent = [
    {
      name: "Alexander Manes",
      position: "Product Manager",
      company: "Abnormal Security",
      image: alex,
    },
    {
      name: "Christina Guo",
      position: "Co-Founder",
      company: "Lookbk",
      image: christina,
    },
    {
      name: "Pranav Gulati",
      position: "Product Manager",
      company: "Uber ",
      image: pranav,
    },
    {
      name: "Omkar Salpekar",
      position: "Staff Software Engineer",
      company: "Facebook",
      image: omkar,
    },
    {
      name: "Pratik Bhat",
      position: "AI Product Lead",
      company: "Drata",
      image: pratik,
    },
    {
      name: "Kathy Kong",
      position: "Product Manager",
      company: "Zoom",
      image: kathy,
    },
    {
      name: "Aashi Jawar",
      position: "Product Marketing Intern",
      company: "TikTok",
      image: aashi,
    },
    {
      name: "Alice Deng",
      position: "Co-Founder",
      company: "Slope Tech",
      image: alice,
    },
    {
      name: "Daniella Wenger",
      position: "Law Clerk",
      company: "Kirkland & Ellis",
      image: daniella,
    },
    {
      name: "Blake LaFayette",
      position: "Principal",
      company: "Alpine Investors",
      image: blake,
    },
    {
      name: "Farbod Nowzad",
      position: "Co-Founder and CEO",
      company: "Cashmere",
      image: farbod,
    },
    {
      name: "Abhay Malik",
      position: "Founding PM",
      company: "Predibase",
      image: abhay,
    },
    {
      name: "Jeff Feng",
      position: "Partner",
      company: "Sierrawood",
      image: jeff,
    },
    {
      name: "Amrit Ayalur",
      position: "Senior Product Engineer",
      company: "Ellipsis Labs",
      image: amrit,
    },
    {
      name: "Damini Satija",
      position: "Director",
      company: "Amnesty Tech",
      image: damini,
    },
    {
      name: "Keyan Sarrafzadeh",
      position: "Growth Product Manager",
      company: "Ramp",
      image: keyan,
    },
    {
      name: "Kirtan Upadhyaya",
      position: "Resident Physician",
      company: "UCI Health",
      image: kirtan,
    },
    {
      name: "Jeremy Fiance",
      position: "Managing Partner in Berkeley",
      company: "The House Fund",
      image: jeremy,
    },
    {
      name: "Cameron Baradar",
      position: "Advisor",
      company: "BAIR",
      image: cameron,
    },
    {
      name: "Sam Kirschner",
      position: "Vice President",
      company: "Village Global",
      image: sam,
    },
    {
      name: "Sean Linehan",
      position: "Co-Founder & CEO",
      company: "Placement.com",
      image: sean,
    },
    {
      name: "Jasmine Stoy",
      position: "Member of Product Staff",
      company: "Simile",
      image: jasmine,
    },
    {
      name: "Nikita Ashok",
      position: "Senior Software Engineer",
      company: "Nourish",
      image: nikita,
    },
    {
      name: "Adhiv Dhar",
      position: "APM",
      company: "Twitter",
      image: adhiv,
    },
    {
      name: "Shaantam Chawla",
      position: "Engineering Lead",
      company: "Privateer Space",
      image: shaantam,
    },
    {
      name: "Saneel Sreeni",
      position: "Head of Special Projects",
      company: "Ritual Foundation",
      image: saneel,
    },
    {
    name: "Joelene Latief",
    position: "Software Engineer",
    company: "Evvy",
    image: joelene,
    },
    {
      name: "LuLu Holland",
      position: "CEO",
      company: "Veritas",
      image: lulu,
    },
    {
      name: "Maanav Khaitan",
      position: "Building",
      company: "Infinity",
      image: maanav,
    },
    {
      name: "Anjan Bharadwaj",
      position: "Member of Technical Staff",
      company: "OpenAI",
      image: anjan,
    },
    {
      name: "Adithya Paramasivam",
      position: "ML Scientist",
      company: "Nabla Bio",
      image: adithya,
    },
    {
      name: "Safwan Masood",
      position: "GTM",
      company: "Cognition",
      image: safwan,
    },
    {
      name: "Varun Nair",
      position: "Growth Engineer",
      company: "Conversion",
      image: varun
    },
    {
      name: "Aamir Hudda",
      position: "Co-Founder & CEO",
      company: "Attain (YC W22)",
      image: aamir
    },
    
    {
      name: "Samiha Singh",
      position: "Business Analyst",
      company: "McKinsey & Co.",
      image: samiha
    },
    
    {
      name: "Shlok Singh",
      position: "Growth",
      company: "Doorstep AI",
      image: shlok
    },
    {
      name: "Alson Chan",
      position: "Product Manager",
      company: "Datadog",
      image: alson
    },
    {
      name: "Amy Zhuang",
      position: "Investor",
      company: "Plug and Play",
      image: amy
    },
    {
      name: "Hriday Sheth",
      position: "Software Engineer",
      company: "Zip",
      image: hriday
    },
    {
      name: "Ishaan Shah",
      position: "Associate",
      company: "Bain & Co.",
      image: ishaan
    },
    {
      name: "Mahika Valluri",
      position: "Product Manager",
      company: "Mercor",
      image: mahika
    },
    {
      name: "Pavit Singh",
      position: "Strategic Projects",
      company: "Scale AI",
      image: pavit
    },
    {
      name: "Radha Singh",
      position: "Product Deployment Strategist",
      company: "Persona",
      image: radha
    },
    {
      name: "Rohan Taneja",
      position: "Software Engineer",
      company: "Vercel",
      image: rohan
    },
    {
      name: "Ashni Sheth",
      position: "Research and Product",
      company: "Turing",
      image: ashni
    },
    {
      name: "Hiya Shah",
      position: "Graduate Robotics Researcher",
      company: "BAIR",
      image: hiya
    },
    {
      name: "Hy Nguyen",
      position: "Founder",
      company: "Tacit Awareness",
      image: hy
    },
    {
      name: "Kelly Hong",
      position: "Researcher",
      company: "Epoch AI",
      image: kelly
    },
    {
      name: "Nandu Narayanan",
      position: "Deployed Engineer",
      company: "Cognition",
      image: nandu
    }
  ];

  let peopleComponents = peopleContent.map((person) => {
    return (
      <Person
        name={person.name}
        position={person.position}
        linkedinUrl={person.linkedinUrl}
        calendlyUrl={person.calendlyUrl}
        mailTo={person.mailTo}
        image={person.image}
      />
    );
  });

  // Magic constant for converting the window scroll position into
  // the alumni scroll position.
  const SCROLL_CONVERT = 730;

  // Magic constant to make the alumni scroll bars start at slightly
  // different lengths.
  const SCROLL_PLUS_MINUS = 1000;

  return (
    <section>
      <GenericTop header={header} description={description}>
        {button}
      </GenericTop>
      <GenericPage>
        <div className="peopleGrid">{peopleComponents}</div>
      </GenericPage>
      <div className="gray" id="internal-alumni">
        <section className="genericTop">
          <div className="container">
            <div className="purpleBorder"></div>
            <div class="topHeader">
              <h1>Internal Alumni</h1>
            </div>
          </div>
        </section>
        <div class="alumni-marquee-wrapper">
          {/* Use this to debug: */}
          {/* <p>{useScrollHandler()}</p> */}
          <AlumniCardsMarquee
            row={1}
            content={alumniContent}
            scrollPosition={useScrollHandler() + SCROLL_CONVERT}
          />
          <AlumniCardsMarquee
            row={2}
            content={alumniContent}
            scrollPosition={
              useScrollHandler() + SCROLL_CONVERT - SCROLL_PLUS_MINUS
            }
          />
          <AlumniCardsMarquee
            row={3}
            content={alumniContent}
            scrollPosition={
              useScrollHandler() + SCROLL_CONVERT + SCROLL_PLUS_MINUS
            }
          />
          <AlumniCardsMarquee
            row={4}
            content={alumniContent}
            scrollPosition={
              useScrollHandler() + SCROLL_CONVERT - (2 * SCROLL_PLUS_MINUS)
            }
          />
          <AlumniCardsMarquee
            row={5}
            content={alumniContent}
            scrollPosition={
              useScrollHandler() + SCROLL_CONVERT - (3 * SCROLL_PLUS_MINUS)
            }
          />
        </div>
      </div>
      <GenericPage>
        <h2 style={{ textAlign: "center", padding: "50px 0" }}>
          Our Advisors come from
        </h2>
        <div className="five-grid">
          <span>
            <img src={house} />
          </span>
          <span>
            <img src={skydeck} />
          </span>
          <span>
            <img src={scet} />
          </span>
          <span>
            <img src={haas} />
          </span>
          <span>
            <img src={berkeleyengineering} />
          </span>
        </div>
      </GenericPage>
    </section>
  );
}

export default Team;
